import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import WarningIcon from '../../assets/icons/AlertModalWarning.png';

export interface ButtonContent {
	buttonText: string;
	buttonOnClick: () => void;
	type: 'text' | 'outlined' | 'contained' | undefined;
}
export interface EventPromptProps {
	heading: string;
	subHeading: string;
	type: string;
	button: ButtonContent[];
	open: boolean;
}
export interface AlertDialogProps {
	heading: string;
	subHeading: string;
	buttons: any;
	open: boolean;
	handleClose: () => void;
}

export const AlertModal: React.FC<AlertDialogProps> = ({
	heading,
	subHeading,
	buttons,
	open,
	handleClose,
}) => {
	return (
		<Backdrop
			sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={open}
		>
			<Modal
				open={open}
				hideBackdrop
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '30%',
					background: '#FFFFFF',
					backgroundColor: '#FFFFFF',
					borderRadius: '8px',
					overflowY: 'auto',
					overflowX: 'hidden',
					paddingX: '10px',
					paddingY: '32px',
				}}
				onClose={handleClose}
			>
				<Box
					sx={{
						bgcolor: 'white',
						alignItems: 'center',
						textAlign: 'center',
						display: 'flex',
						flexDirection: 'column',
						':focus': {
							outline: 'none',
						},
					}}
				>
					<div style={{ width: '200px', height: '200px' }}>
						<img
							src={WarningIcon}
							style={{ objectFit: 'contain' }}
							alt="Warning Icon"
						/>
					</div>
					<Typography
						sx={{
							margin: '20px 0 12px 10px',
							width: '100%',
							fontSize: '26px',
							overflowWrap: 'break-word',
						}}
					>
						{heading}
					</Typography>
					<Typography
						sx={{
							fontWeight: '400',
							fontSize: '16px',
							lineHeight: '26px',
							textAlign: 'center',
							width: '90%',
							color: 'rgba(0,0,0,0.8)',
						}}
						id="alert-dialog-slide-description"
					>
						{subHeading}
					</Typography>
					<Box
						key="alertdialog"
						sx={{
							width: '100%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							marginTop: '40px',
						}}
					>
						{buttons.map((button: any, index: number) => {
							return (
								<Button
									variant={button.type}
									key={index}
									sx={
										button.type === 'contained'
											? {
													background: '#953730',
													marginRight: '20px',
													borderRadius: '8px',
													':hover': {
														background: '#953730',
														scale: '1.01',
													},
											  }
											: {
													borderRadius: '8px',
													border: '1px solid #953730',
													':hover': {
														background: 'white',
														border: '1px solid #953730',
														scale: '1.01',
													},
													color: '#953730',
											  }
									}
									onClick={button.onClick}
								>
									{button.buttonText}
								</Button>
							);
						})}
					</Box>
				</Box>
			</Modal>
		</Backdrop>
	);
};

export default AlertModal;
